import { Col, Row, Container, Typography } from 'darrius';

import { shouldRenderComponent } from '../../../utils/shouldRenderComponent';

import { AdsBackButton } from '.';

import styles from './AdsHeroSection.module.scss';

import { IUserTransformationReturn } from '../../../modules/profile/shared/transformations/user/@interfaces';

type THeroSectionData = {
  user: IUserTransformationReturn;
  mainSection: {
    breadcrumbs: {
      items: {
        name: string;
        url: string;
      }[];
      structuredData: string;
    };
    title: string;
  };
};

interface IAdsHeroSectionProps {
  heroSectionData: THeroSectionData;
  isInstantMatch?: boolean;
  isUserCliAuthenticated?: boolean;
}

export const AdsHeroSection = ({
  heroSectionData,
  isInstantMatch,
  isUserCliAuthenticated = false,
}: IAdsHeroSectionProps) => {
  const { mainSection, user } = heroSectionData;

  return (
    <>
      <Container>
        <Row>
          <Col className={`col-sm-12 ${styles['hero-section_top-buttons']}`}>
            {shouldRenderComponent(
              [isInstantMatch, isUserCliAuthenticated],
              () => (
                <div>
                  <AdsBackButton />
                </div>
              )
            )}
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="bottom-sm">
          <Col className="col-sm-12 col-md-7 col-lg-6">
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: mainSection.breadcrumbs.structuredData,
              }}
            />
            <Row>
              <Col
                className={`${styles['profile-prices-hero__title']} col-sm-12`}
              >
                <Typography.Title size="2xl">
                  Contratar serviço
                </Typography.Title>
                <Typography.Text className={styles.text}>
                  Serviços oferecidos por <b>{user.name}</b>
                </Typography.Text>
              </Col>
            </Row>

            <Row>
              <Col className={`col-12 col-sm-12 col-md-12`}>
                <div className={styles['profile-prices-hero-info']}>
                  <img
                    alt="Ícone de empresa parceira"
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/calendar.svg`}
                    width={24}
                    height={24}
                  />
                  <div>
                    <p className={styles['profile-prices-hero-info__text']}>
                      O profissional conversará com você para agendar o serviço{' '}
                      <strong>após o pagamento.</strong>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};
